/* eslint-disable react/prop-types */
import { UpsellBaseModal } from '../UpsellBaseModal'
import baseModalStyles from '../UpsellBaseModal/styles.module.css'
import { OfferBox } from '../OfferBox'
import styles from './styles.module.css'

export const DiscountModal = ({
  isOpen,
  onClose,
  title = 'Espera! Um presente de primeira compra.',
  subtitle = '20% off para baixar sua campanha agora + 10 artes.',
  offer,
  footnote,
  primaryAction,
  dismissAction,
  showCloseButton = true,
}) => {
  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      titleId="discount-modal-title"
      titleClassName={styles.modalTitle}
      headerClassName={styles.modalHeader}
      subtitleClassName={styles.modalSubtitle}
      contentClassName={styles.modalContent}
      footerClassName={styles.modalFooter}
      showCloseButton={showCloseButton}
      secondaryAction={dismissAction}
    >
      {offer && (
        <OfferBox
          variant="dashed"
          label={offer.label}
          couponCode={offer.couponCode}
          couponText={offer.couponText}
          couponValidityText={offer.couponValidityText}
          price={offer.price}
          originalPrice={offer.originalPrice}
          description={offer.description}
          subdescription={offer.subdescription}
          unitPrice={offer.unitPrice}
          timerSeconds={offer.timerSeconds}
          timerLabel={offer.timerLabel}
          onTimerExpire={offer.onTimerExpire}
        />
      )}

      {primaryAction && (
        <button
          type="button"
          className={baseModalStyles.primaryButton}
          onClick={primaryAction.onClick}
          disabled={primaryAction.disabled}
        >
          {primaryAction.label}
        </button>
      )}

      {footnote && <p className={styles.footnote}>{footnote}</p>}
    </UpsellBaseModal>
  )
}

export default DiscountModal
